import { InjectionToken } from '@angular/core';
import { IPermissionService } from '@/core/interface/permission-service.interface';

/** DIP: consumers inject IPermissionService, not the concrete PermissionService */
export const PERMISSION_SERVICE_TOKEN = new InjectionToken<IPermissionService>('PERMISSION_SERVICE_TOKEN');
